import React, { useContext } from 'react';
import { InterceptorPopUpContext } from '../../../contexts/interceptorPopUpContext.js';
import ActionToastComponent from '../ActionToastComponent.js';
import './InterceptorPopUpList.scss';

const InterceptorPopUpList = () => {
  const { popUps } = useContext(InterceptorPopUpContext);
    
  return (
     
    popUps.map((popUp,i) => 
      <div key={`${popUp.text}--${i}`} id={`offset${i}`}>
        <ActionToastComponent
          isOpen={true}
          description={popUp.text}
          dismissible
          onClick={close}
          onClose={close}
          duration={3500}
        />
      </div>
    )
  );
};

export default InterceptorPopUpList;
